import services from '@/services.js'

export default {
  // Create and Import Audience
  getSelectTypes: ({ commit }, clienteId) => {
    return new Promise((resolve, reject) => {
      services
        .fieldtypes(clienteId)
        .then((response) => {
          const groupsClient = response.data.data.groups

          groupsClient[0].categories.forEach((el) => {
            el.types.forEach((item) => {
              item.group = 'DEFAULT'
            })
          })

          if (groupsClient[1]) {
            groupsClient[1].value = 'CUSTOM'
            groupsClient[1].types.forEach((el) => {
              el.group = 'CUSTOM'
            })
          }

          const groups = [...groupsClient[0].categories, groupsClient[1]]

          commit('ADD_SELECT_TYPES', groups)
          resolve(true)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  getDefaultFieldDataTypes: ({ commit }, clienteId) => {
    return new Promise((resolve, reject) => {
      services
        .defaultFieldDataTypes(clienteId)
        .then((response) => {
          let types = response.data.data.map((type) => {
            return {
              dataType: type,
              group: 'new',
              value: `NEW ${type.value} FIELD`,
            }
          })

          let defaultknow = {
            group: 'newCustom',
            value: '+ Add Custom',
            types,
          }

          commit('ADD_DEFAULT_SELECT_TYPES', defaultknow)

          resolve(true)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  updateTypeItem: ({ commit, dispatch }, payload) => {
    commit('UPDATE_TYPE', payload)
    commit('ADD_COLUMN', null) // TODO trick correção de problema com reatividade da escolha do tipo data em uma nova coluna
    if (payload.new) {
      dispatch('setNewType', payload)
    }
  },

  setNewType: ({ commit }, payload) => {
    commit('UPDATE_SELECT_TYPES', payload)
  },

  addColumn: ({ commit }, column) => {
    commit('ADD_COLUMN', column)
  },

  updateMainColumn: ({ commit }, values) => {
    let items
    if (Array.isArray(values.items)) {
      items = values.items.reduce((acc, cur) => {
        acc.push(cur.fileColumnPosition)
        return acc
      }, [])

      commit('UPDATE_MAIN_COLUMN', { event: values.event, items })
      return
    }

    commit('UPDATE_MAIN_COLUMN', values)
  },

  removeMainColumn: ({ commit }, position) => {
    commit('REMOVE_MAIN_COLUMN', position)
  },

  editColumn: ({ commit }, position) => {
    commit('EDIT_COLUMN', position)
    commit('REMOVE_MAIN_COLUMN', position)
  },

  actionProperty: ({ commit }, payload) => {
    //TODO errado - Deve alterar essa mudança de estado para a mutation
    if (payload.state == 3) {
      payload.type = null
      payload.state = { key: 3, value: 'IGNORED' }
      commit('ACTION_PROPERTY', payload)
      return
    }

    payload.state = { key: 2, value: 'MAPPED' }
    commit('ACTION_PROPERTY', payload)
  },

  setResultUpload: ({ commit }, payload) => {
    payload.data.items.forEach((element) => {
      element.edit = true
      element.predefinedFormat = element.format
    })

    localStorage.setItem('audience', JSON.stringify(payload))

    commit('SET_RESULT_UPLOAD', payload)
  },

  clearSummary: ({ commit }) => {
    commit('CLEAR_SUMMARY')
  },

  hasAudience: async ({ commit }, organizationId) => {
    try {
      const result = await services.hasAudience(organizationId)
      if (result.data.data) {
        commit('UPDATE_HAS_AUDIENCE', true)
        return
      }
      commit('UPDATE_HAS_AUDIENCE', false)
    } catch (error) {
      commit('UPDATE_HAS_AUDIENCE', false)
      throw error
    }
  },

  hasAudienceInProcess: async ({ commit }, clienteId) => {
    return new Promise((resolve, reject) => {
      services
        .hasAudienceInProcess(clienteId)
        .then((response) => {
          if (response.data.data) {
            commit('UPDATE_STATUS_AUDIENCE', true)
            resolve(true)
            return
          }
          commit('UPDATE_STATUS_AUDIENCE', false)
          resolve(false)
        })
        .catch((error) => {
          reject(error.response.data.message)
          commit('UPDATE_STATUS_AUDIENCE', false)
        })
    })
  },

  addTags({ commit }, tags) {
    commit('UPDATE_TAGS', tags)
  },

  // Detail
  getSchema: ({ commit }, organizationId) => {
    return new Promise((resolve, reject) => {
      services
        .audienceSchema(organizationId)
        .then(({ data }) => {
          commit('UPDATE_SCHEMA_AUDIENCE', data.data)
          resolve(true)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  getRecipientId: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      services
        .getRecipientId(payload.organizationId, payload.recipientId)
        .then(({ data }) => {
          commit('UPDATE_RECIPIENT', data.data)
          resolve(true)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  updateAudienceFeed: ({ commit }, feed) => {
    commit('UPDATE_AUDIENCE_FEED', feed)
  },

  // NEW Audience
  setImportContactsStep({ commit }, step) {
    commit('SET_IMPORT_CONTACTS_STEP', step)
    window.scrollTo({ top: 0, behavior: 'smooth' });
  },

  setImportContactsValidSteps({ commit }, validSteps) {
    commit('SET_IMPORT_CONTACTS_VALID_STEPS', validSteps)
  },

  setImportContactsCompletedSteps({ commit }, completedSteps) {
    commit('SET_IMPORT_CONTACTS_COMPLETED_STEPS', completedSteps)
  },

  clearImportContactsState({ commit }) {
    commit('CLEAR_IMPORT_CONTACTS_STATE')
  },

  setImportedData({ commit }, data) {
    commit('SET_IMPORTED_DATA', data)
  },

  updateImportedDataItem({ commit }, data) {
    commit('UPDATE_IMPORTED_DATA_ITEM', data)
  },

  setColumnAsKey({ commit }, data) {
    commit('SET_COLUMN_AS_KEY', data)
  },

  addImportedDataTags({ commit }, tags) {
    commit('ADD_IMPORTED_DATA_TAGS', tags)
  },

  setImportSuccess({ commit }, value) {
    commit('SET_IMPORT_SUCCESS', value)
  },
}
